import type { SiteContent } from '@/lib/cms-types';
import { apiGet, apiPut } from './api-client';

type SiteResponse = { data: SiteContent };

export async function getSiteContent(): Promise<SiteContent | null> {
  try {
    const res = await apiGet<SiteResponse>('/site');
    return res.data ?? null;
  } catch {
    return null;
  }
}

export async function updateSiteContent(site: SiteContent): Promise<SiteContent> {
  const res = await apiPut<SiteResponse>('/admin/site', site, true);
  return res.data;
}

export async function patchSiteHero(patch: Partial<SiteContent['hero']>): Promise<SiteContent> {
  const res = await apiPut<SiteResponse>('/admin/site/hero', patch, true);
  return res.data;
}

export async function updateStaff(
  members: SiteContent['staffMembers'],
  meta?: Partial<
    Pick<SiteContent, 'staffPageTitle' | 'staffPageSubtitle' | 'staffRoleDescriptions'>
  >
): Promise<SiteContent> {
  const res = await apiPut<SiteResponse>(
    '/admin/site/staff',
    {
      members,
      ...(meta?.staffPageTitle !== undefined ? { staffPageTitle: meta.staffPageTitle } : {}),
      ...(meta?.staffPageSubtitle !== undefined ? { staffPageSubtitle: meta.staffPageSubtitle } : {}),
      ...(meta?.staffRoleDescriptions !== undefined
        ? { staffRoleDescriptions: meta.staffRoleDescriptions }
        : {}),
    },
    true
  );
  return res.data;
}

export async function updateRules(
  payload: Partial<
    Pick<SiteContent, 'rulesSections' | 'rulesPageTitle' | 'rulesPageSubtitle'>
  > & { sections?: SiteContent['rulesSections'] }
): Promise<SiteContent> {
  const res = await apiPut<SiteResponse>(
    '/admin/site/rules',
    {
      sections: payload.sections ?? payload.rulesSections,
      ...(payload.rulesPageTitle !== undefined ? { rulesPageTitle: payload.rulesPageTitle } : {}),
      ...(payload.rulesPageSubtitle !== undefined
        ? { rulesPageSubtitle: payload.rulesPageSubtitle }
        : {}),
    },
    true
  );
  return res.data;
}

export async function updateConduct(conduct: SiteContent['conduct']): Promise<SiteContent> {
  const res = await apiPut<SiteResponse>('/admin/site/conduct', conduct, true);
  return res.data;
}

export async function updateFooter(
  footer: SiteContent['footer'],
  identity?: Partial<SiteContent['identity']>
): Promise<SiteContent> {
  const res = await apiPut<SiteResponse>(
    '/admin/site/footer',
    {
      ...footer,
      ...(identity ? { identity } : {}),
    },
    true
  );
  return res.data;
}
